import {CacheState} from "./CacheState";
import {User} from "../../model/user/User";

export class UserState implements CacheState {
    constructor(public user: User | null = null,
                public pendingRequest: boolean = false,
                public loaded: boolean = false) {}
}